<template>
  <section>
    <div class="container">
      <div class="row mb-5">
        <div class="col d-flex align-items-center">
          <div class="d-inline-block p-3 p-md-4 rounded-circle bg-primary-alt">
            <img src="assets/img/icons/theme/general/settings-1.svg" />
          </div>
          <div class="ml-4">
            <h3 class="mb-2">Keranjang Belanja Anda</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8">
          <div class="row">
            <a class="col-4" href="#">
              <img
                class="rounded img-fluid hover-fade-out"
                src="assets/img/products/product-01.png"
                alt="blog.2.image"
              />
            </a>
            <div class="col">
              <div class="d-flex justify-content-between">
                <p class="lead">Soto Ayam Lamongan Cak Har</p>
                <a href="#" class="btn btn-sm btn-danger rounded-circle">
                  <i class="fas fa-trash"></i>
                </a>
              </div>
              <p class="primary lead mb-3">
                <strong>Rp 15,000</strong>
              </p>
              <p class="text-small text-muted">
                Open P.O oleh-oleh express khas Bali
                <br />Pipit Agustin
              </p>

              <div class="d-flex justify-content-between">
                <div>
                  <number-input @click="calculate" v-model="qty" :min="1" :max="10" inline controls></number-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <span>Ringkasan Belanja</span>
              <hr />
              <animated-number :value="value" :formatValue="formatToPrice" :duration="300"/>
              <router-link to="/address" class="btn btn-danger d-sm-block order-lg-3" tag="a"> Beli ({{ qty }}) </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AnimatedNumber from "animated-number-vue";

export default {
  name: "Keranjang",
    components: {
    AnimatedNumber
  },
  data() {
    return {
      qty: 1,
      value: 15000
    };
  },
  methods: {
    formatToPrice(value) {
      return `<h3>Rp ${Number(value).toFixed(2)}</h1>`;
    },
    calculate() {
      this.value = 15000 * Number(this.qty);
    }
  }
};
</script>
